import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document",
  "use": "icon-document-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-document\">\n<path d=\"M6.25 2C5.0095 2 4 3.0095 4 4.25V19.75C4 20.9905 5.0095 22 6.25 22H17.75C18.9905 22 20 20.9905 20 19.75V10H14.25C13.0095 10 12 8.9905 12 7.75V2H6.25ZM13.5 2.43945V7.75C13.5 8.1635 13.8365 8.5 14.25 8.5H19.5605L13.5 2.43945ZM8.75 12.5H15.25C15.664 12.5 16 12.836 16 13.25C16 13.664 15.664 14 15.25 14H8.75C8.336 14 8 13.664 8 13.25C8 12.836 8.336 12.5 8.75 12.5ZM8.74512 16H13.2432C13.6572 16 13.9932 16.3355 13.9932 16.75C13.9937 17.1295 13.7117 17.4437 13.3457 17.4932L13.2441 17.5H8.74609C8.33209 17.5 7.99609 17.164 7.99609 16.75C7.99609 16.3705 8.27755 16.0563 8.64355 16.0068L8.74512 16Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/document.svg
// module id = 4gVc
// module chunks = 262